import { ENV } from '../config/env';
import { apiFetch } from './client';
import { getExamToken } from '../auth/examToken';

const BASE = ENV.PHP_API_BASE;
if (!BASE) console.warn('REACT_APP_PHP_BASE_URL not set');

// The exam token travels in the body (exam_token) so the existing PHP CORS preflight rules are unchanged.
const withToken = (payload) => ({ ...(payload || {}), exam_token: getExamToken() || undefined });

const formWithToken = (fields) => {
  const form = new URLSearchParams();
  Object.entries(fields).forEach(([k, v]) => {
    if (v != null) form.append(k, v);
  });
  const token = getExamToken();
  if (token) form.append('exam_token', token);
  return form;
};

export async function getQuestions(payload) {
  return apiFetch(`${BASE}/getQuestions`, { method: 'POST', body: withToken(payload) });
}

export async function submitExam(payload) {
  return apiFetch(`${BASE}/submitExam`, { method: 'POST', body: withToken(payload) });
}

export async function recordViolation(payload) {
  return apiFetch(`${BASE}/recordViolation`, { method: 'POST', body: withToken(payload) });
}

export async function checkExamStatus(payload) {
  return apiFetch(`${BASE}/checkExamStatus`, { method: 'POST', body: withToken(payload) });
}

export async function startLiveSession(payload) {
  const form = formWithToken({
    room_id: payload.room_id,
    course_code: payload.course_code,
    exam_date: payload.exam_date,
  });
  return apiFetch(`${BASE}/startLiveSession`, { method: 'POST', body: form });
}

export async function updateLiveSessionStatus(payload) {
  const form = formWithToken({
    room_id: payload.room_id,
    status: payload.status,
  });
  return apiFetch(`${BASE}/updateLiveSessionStatus`, { method: 'POST', body: form });
}

// Form-encoded + keepalive: no CORS preflight, and the request survives the page navigating away right after it.
export function logExamActivity(payload) {
  const form = formWithToken({
    registration_id: payload.registration_id,
    event: payload.event,
    device: payload.device,
    ago_ms: payload.ago_ms,
  });
  return apiFetch(`${BASE}/logExamActivity`, { method: 'POST', body: form, keepalive: true });
}

export async function getExamActivityLogs(payload) {
  return apiFetch(`${BASE}/getExamActivityLogs`, { method: 'POST', body: withToken(payload) });
}

export function getPhpBaseUrl() {
  return BASE;
}
